import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';
Vue.use(VueRouter);

const routes = [
  {
    path: '/spaceOrder/spaceList',
    name: 'spaceReservationSpaceList',
    component: () => import('@/sub-app/spaceOrder/pages/spaceList.vue'),
    meta: {
      title: '空间预定',
      keepAlive: false,
    },
  },
  {
    path: '/spaceOrder/spaceDetails',
    name: 'spaceReservationSpaceDetails',
    component: () => import('@/sub-app/spaceOrder/pages/components/spaceDetails.vue'),
    meta: {
      title: '空间预定详情',
      keepAlive: false,
    },
  },
  // 添加时间选择
  {
    path: '/spaceOrder/spaceBalance',
    name: 'spaceReservationSpaceBalance',
    component: () => import('@/sub-app/spaceOrder/pages/components/spaceBalance.vue'),
    meta: {
      title: '空间预定',
      keepAlive: false,
    },
  },
  // 确认订单页面
  {
    path: '/spaceOrder/spaceConfirmOrder',
    name: 'spaceReservationSpaceConfirmOrder',
    component: () => import('@/sub-app/spaceOrder/pages/components/spaceConfirmOrder.vue'),
    meta: {
      title: '确认订单',
      keepAlive: false,
    },
  },
  // 我的页面
  {
    path: '/spaceOrder/myOrderList',
    name: 'spaceReservationMyOrderList',
    component: () => import('@/sub-app/spaceOrder/pages/myOrderList.vue'),
    meta: {
      title: '我的订单',
      keepAlive: false,
    },
  },
  // 订单详情页面
  {
    path: '/spaceOrder/spaceOrderDetails',
    name: 'spaceReservationSpaceOrderDetails',
    component: () => import('@/sub-app/spaceOrder/pages/components/spaceOrderDetails.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false,
    },
  },
  // 空间预定管理页面
  {
    path: '/spaceOrder/spaceReservatManage',
    name: 'spaceReservationSpaceReservatManage',
    component: () => import('@/sub-app/spaceOrder/pages/spaceReservatManage.vue'),
    meta: {
      title: '空间预定管理',
      keepAlive: false,
    },
  },
  // 审核订单页面
  {
    path: '/spaceOrder/reviewOrderPage',
    name: 'spaceReservationreviewOrderPage',
    component: () => import('@/sub-app/spaceOrder/pages/components/reviewOrder.vue'),
    meta: {
      title: '审核订单',
      keepAlive: false,
    },
  },
  // 审核订单详情页面
  {
    path: '/spaceOrder/reviewOrderDetails',
    name: 'spaceReservationReviewOrderDetails',
    component: () => import('@/sub-app/spaceOrder/pages/components/reviewOrderDetails.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false,
    },
  },
  // 新增-H5侧预定页面
  {
    path: '/spaceOrder/reserveList',
    name: 'spaceOrderReserveList',
    component: () => import('@/sub-app/spaceOrder/pages/reserveList.vue'),
    meta: {
      title: '预定视图',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
    localStorage.setItem('appName',title)
  }
  document.title = title;
  next();
});

export default router;
